import { QUESTION_RELEASE_CACHED_REPOSITORY, FORM_RELEASE_CACHED_REPOSITORY } from '../core';
import { TAG_WEB_CACHED, TagWebCached, FORM_CATEGORY_WEB_CACHED, FormCategoryWebCached, QuestionReleaseInMemoryCached, FormReleaseInMemoryWebCached } from './data-sources';
export var cachedProviders = [{
  provide: TAG_WEB_CACHED,
  useFactory: function useFactory() {
    return new TagWebCached();
  }
}, {
  provide: FORM_CATEGORY_WEB_CACHED,
  useFactory: function useFactory() {
    return new FormCategoryWebCached();
  }
}, {
  provide: QUESTION_RELEASE_CACHED_REPOSITORY,
  useFactory: function useFactory() {
    return new QuestionReleaseInMemoryCached();
  }
}, {
  provide: FORM_RELEASE_CACHED_REPOSITORY,
  useFactory: function useFactory() {
    return new FormReleaseInMemoryWebCached();
  }
}];